import "./index.css";
import { useState } from "react";

export const Square = ({ value, onClick, color }) => (
  <button className="square" style={{ backgroundColor: color }} onClick={() => onClick(value)}/>
)
